import { render, staticRenderFns } from "./appLeft.vue?vue&type=template&id=a16b7b8a&"
import script from "./appLeft.vue?vue&type=script&lang=js&"
export * from "./appLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports